import HttpService from './http.service.js'

class DashboardService {
  async answers() {
    const answersEndpoint = 'dashboard/answers'
    return HttpService.get(answersEndpoint)
  }
}

export default new DashboardService()
